import { remark } from '@/views/fin/salaryadministration/constants.js'
export default {
    methods: {
        successRemark() {
            this.$vModal.info({
                title: '提示',
                content: remark
            })
        },
    }
}